export default "__VITE_ASSET__Cu$ww18W__"